<template>
  <section class="voucher">
    <div class="voucher-title">
      <img :src="voucherIcon" alt="" />
      <p>{{ voucher.voucherName.slice(0, 10) }}</p>
    </div>
    <section class="voucher-body-container">
      <div class="voucher-body">
        <h2>{{ voucherTitle }}</h2>
        <h5 v-if="voucher.minOrderValue">
          Min Spend {{ voucher.minOrderValue }}
        </h5>
        <h5 v-if="voucher.maxDiscount">{{ $t("voucherInfo.CappedAt") }} {{ voucher.maxDiscount }}</h5>
        <!-- <h5>Capped at Rs 250</h5> -->
        <h6 class="valid-date">{{ validDate }}</h6>
      </div>
      <button
        :disabled="isButtonDisabled"
        :class="isButtonDisabled == true ? 'voucher-collected' :'voucher-collect'"
        @click="collectVoucher"
      >
        {{ buttonText }}
      </button>
    </section>
  </section>
</template>

<script>
import { collectVoucher, redeemCollectableVoucher } from "@/api/product";
import { useLoginStore } from "@/stores/userStore";
import catchTokenError from "@/utils/catchInvalidTokenError";

import { toast } from 'vue3-toastify'

export default {
  // -- COLLECT VOUCHER --
  // SHOP : 1; PRODUCT : 2; ALL : 3

  //  -- TYPE OF DISCOUNTS --
  // 1 -> Money value
  // 2 -> Percnentage value
  // 3 -> Free Shipping

  // -- PLEASE REFER THE VOUCHER DOCUMENTATION --

  props: {
    voucher: { type: Object, required: true },
  },
  setup() {
    const userStore = useLoginStore();
    const isLogged = userStore.isLoggedIn()
    return {isLogged};
  },
  data() {
    return {
      applyToIcons: {
        1: require("@/assets/icons/svg/shop-voucher.svg"),
        2: require("@/assets/icons/svg/product-voucher.svg"),
        3: require("@/assets/icons/svg/platform-voucher.svg"),
      },
    };
  },
  computed: {
    voucherIcon() {
      return this.applyToIcons[this.voucher.applyTo];
    },
    voucherTitle() {
      switch (this.voucher.discountType) {
        case 1:
          return `${this.voucher.currencyUnit} ${this.voucher.discountAmount}`;
        case 2:
          return `${this.voucher.discountPercentage}${this.$t('voucherInfo.PercentageDiscount')}`;
        case 3:
          return this.$t('voucherInfo.FreeShipping');
        default:
          return "Default Value";
      }
    },
    validDate() {
      const getFormatedDate = (date) => {
        const d = new Date(date);
        return `${d.toLocaleString("default", {
          month: "long",
        })}-${d.getDate()}`;
      };

      return `${this.$t("voucherInfo.VoucherValidDate")} ${getFormatedDate(
        this.voucher.redeemStartTime
      )} - ${getFormatedDate(this.voucher.redeemEndTime)}`;
    },
    buttonText() {
      if (
        this.voucher.isCompletelyCollected &&
        (this.voucher.isFromCollectedPage || this.voucher.isFromSummaryCard)
      ) {
        return this.$t('voucherInfo.VoucherApply');
      } else if (this.voucher.isCompletelyCollected) {
        return this.$t('voucherInfo.VoucherCollected');
      } else return this.$t('voucherInfo.VoucherCollect');
    },
    isButtonDisabled(){
      if (
        this.voucher.isCompletelyCollected &&
        (this.voucher.isFromCollectedPage || this.voucher.isFromSummaryCard)
      ) {
        return false;
      } else if (this.voucher.isCompletelyCollected) {
        return true;
      } else return false;
    }
  },
  methods: {
    async collectVoucher() {

      if (!this.isLogged) {
        toast.error(this.$t('message.LoginToMall'));
        return
      }
      if (this.voucher.isCompletelyCollected && this.voucher.isFromSummaryCard) {
        try {
          const {data} = await redeemCollectableVoucher(this.voucher.voucherId)
          this.$emit("redeemCollectableVoucher",data);
          toast.success(this.$t('voucherInfo.VoucherCollectedMessage'));
        } catch (error) {
          toast.error(this.$t("voucherInfo.VoucherCollectError"));
        }
      }
      else if (this.voucher.isCompletelyCollected) {
        switch (this.voucher.applyTo) {
          case 1:
            if (this.voucher.idValues[0]) {
              this.$router.push("/store/" + this.voucher.idValues[0]);
            } else this.$router.push("/");
            break;
          case 2:
            if (this.voucher.idValues[0]) {
              this.$router.push("/product/" + this.voucher.idValues[0]);
            } else this.$router.push("/");
            break;

          default:
            this.$router.push("/");
            break;
        }
      } else {
        try {
          await collectVoucher(this.voucher.voucherId);
          toast.success(this.$t('voucherInfo.VoucherCollectedMessage'));
          // eslint-disable-next-line
          this.voucher.isCompletelyCollected = true;
        } catch (error) {
          catchTokenError(error);
        }
      }
    },
  },
};
</script>

<style lang="sass">
@import "@/assets/styles/__voucher.sass"

</style>
